<template>
    <targeting-router-link v-if="hasTarget" :to="routeTo" class="text-primary">
        {{ formattedValue }}
    </targeting-router-link>
    <span v-else>{{ formattedValue }}</span>
</template>

<script setup lang="ts">
import {TargetingRouterLink, PanelContentRequest} from '@tritt/multipanel'
import {GENERAL_LEDGER} from '@/genleg'
import {computed, provide} from 'vue'
import {formatCurrency} from '@/services/formatter.service'

const props = defineProps({
    params: {
        type: Object as () => {
            value: number,
            node: { expanded: boolean },
            data: { accountNo: string, fromAccountNo?: string, toAccountNo?: string },
            context: {
                panelId: any,
                panelPathSegment: any
            },
            fromDate?: string,
            toDate?: string,
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const accountNo = computed(() => props.params.data?.accountNo || undefined)
const fromAccountNo = computed(() => props.params.data?.fromAccountNo)
const toAccountNo = computed(() => props.params.data?.toAccountNo)

const hasTarget = computed(() => !!accountNo.value || !!(fromAccountNo.value && toAccountNo.value))

const formattedValue = computed(() => {
    if (props.params.node.expanded) return ''
    return formatCurrency(props.params.value, 0)
})

const routeTo = computed<PanelContentRequest>(() => {
    const queryValues: Record<string, string> = {}
    if (accountNo.value) {
        queryValues.accountNo = accountNo.value
    } else {
        if (fromAccountNo.value) queryValues.fromAccountNo = fromAccountNo.value
        if (toAccountNo.value) queryValues.toAccountNo = toAccountNo.value
    }
    if (props.params.fromDate) queryValues.fromDate = props.params.fromDate
    if (props.params.toDate) queryValues.toDate = props.params.toDate
    return {...GENERAL_LEDGER, queryValues}
})
</script>
